export const env = {
  apiUrl: import.meta.env.VITE_API_URL || 'https://dev.api.alerte-immo.fr/api/v1/alerte-immo',
  landingUrl: import.meta.env.VITE_LANDING_URL || 'http://localhost:4321',
} as const
